import { mount } from 'svelte';
import '@fontsource-variable/space-grotesk/wght.css';
import './app.css';
import App from './App.svelte';

mount(App, { target: document.getElementById('app')! });

// Halo lumineux qui suit le pointeur sur les cartes (désactivé si l'utilisateur réduit les animations).
if (!matchMedia('(prefers-reduced-motion: reduce)').matches && matchMedia('(pointer: fine)').matches) {
  let frame = 0;
  addEventListener(
    'pointermove',
    (e: PointerEvent) => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const card = (e.target as HTMLElement | null)?.closest?.('.card') as HTMLElement | null;
        if (!card) return;
        const r = card.getBoundingClientRect();
        card.style.setProperty('--mx', `${e.clientX - r.left}px`);
        card.style.setProperty('--my', `${e.clientY - r.top}px`);
      });
    },
    { passive: true },
  );
}

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
}
